export default __webpack_public_path__ + "locales/de/UploadPanel.json?hash=d946cecdc021deaf0585a5bd23c5eb47";